<template>
  <nav class="kn-bottom-nav" aria-label="Основная навигация">
    <router-link
      v-if="$canAndRulesPass(user, $permissions.HOME_DASHBOARD.SEE_IN_MENU)"
      :to="{name: 'Home'}"
      exact
      class="kn-bottom-nav__item"
    >
      <i class="fas fa-home"></i><span>Главная</span>
    </router-link>
    <router-link
      v-if="$canAndRulesPass(user, $permissions.CARD.LIST)"
      :to="{name: 'Cards'}"
      class="kn-bottom-nav__item"
    >
      <i class="far fa-id-card"></i><span>Карты</span>
    </router-link>
    <button type="button" class="kn-bottom-nav__item" @click="$emit('open-search')">
      <i class="fas fa-search"></i><span>Поиск</span>
    </button>
    <button type="button" class="kn-bottom-nav__item" @click="$emit('open-menu')">
      <i class="fas fa-bars"></i><span>Меню</span>
    </button>
  </nav>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "mobile-bottom-nav",
  computed: {
    ...mapGetters(['user']),
  },
}
</script>

<style lang="scss">
.kn-bottom-nav {
  display: none;
}

@media (max-width: 767px) {
  .kn-bottom-nav {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    display: flex;
    height: var(--kn-bottom-nav-height);
    padding-bottom: env(safe-area-inset-bottom);
    background-color: var(--kn-card);
    border-top: 1px solid var(--kn-border);
    box-shadow: 0 -8px 24px rgba(26, 26, 46, 0.06);

    &__item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 4px;
      border: 0;
      background: transparent;
      color: var(--kn-text-muted);
      font-family: inherit;
      font-size: 11px;
      font-weight: 500;
      text-decoration: none;
      cursor: pointer;

      i { font-size: 18px; }

      &.router-link-active {
        color: var(--kn-primary);
      }
    }
  }
}
</style>
